export const MEASUREMENT_ZONES = ['upper', 'middle', 'lower'] as const
export type MeasurementZone = (typeof MEASUREMENT_ZONES)[number]

// Internal UI types, pending the medical API contract. Decimal values stay strings.
export interface MeasurementInputRules {
  unit: string
  decimalPlaces: number
  minimum: string
  maximum: string
}

export interface MeasurementValues {
  before: Partial<Record<MeasurementZone, string>>
  after: Partial<Record<MeasurementZone, string>>
}

export interface MeasurementSubmission extends MeasurementValues {
  expectedRevision?: number
  correctionReason?: string
}

export type MeasurementFormMode = 'capture' | 'correction'

export type ExclusionAnswer = 'YES' | 'NO'

export interface ExclusionCatalog {
  formVersionId: string
  versionLabel: string
  questions: readonly { id: string; label: string; required: boolean }[]
}

export interface ExclusionSubmission {
  formVersionId: string
  answers: Record<string, ExclusionAnswer>
}
